const keys = {
  COTACAO_PRODUTO: {
    key: 'COTACAO_PRODUTO',
  },
  COMPRA_PRODUTO: {
    key: 'COMPRA_PRODUTO',
  },
  REQUISICAO_PRODUTO: {
    key: 'REQUISICAO_PRODUTO',
  },
  REQUISICAO: {
    key: 'REQUISICAO',
  },
  COMPRA: {
    key: 'COMPRA',
  },
  FORNECEDOR: {
    key: 'FORNECEDOR',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
